import { render, staticRenderFns } from "./departements.vue?vue&type=template&id=62b9bc74&scoped=true"
import script from "./departements.vue?vue&type=script&lang=js"
export * from "./departements.vue?vue&type=script&lang=js"
import style0 from "./departements.vue?vue&type=style&index=0&id=62b9bc74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b9bc74",
  null
  
)

export default component.exports